import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "ns_cookie_consent";

export default function CookieBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    }, []);

    const accept = (level) => {
        localStorage.setItem(STORAGE_KEY, level);
        setOpen(false);
    };

    if (!open) return null;
    return (
        <div
            role="dialog"
            aria-live="polite"
            aria-label="Cookie consent"
            className="fixed bottom-0 inset-x-0 z-[60] m-3 md:m-6 max-w-3xl md:mx-auto bg-white border border-navy-100 shadow-glow rounded-2xl p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4"
        >
            <div className="text-sm text-navy-700 flex-1">
                We use a small number of cookies for essential site functionality and
                aggregate analytics (Plausible / Yandex.Metrika). Read our{" "}
                <Link to="/privacy" className="text-brand-emerald underline hover:text-brand-deep">
                    Privacy Policy
                </Link>{" "}
                for details.
            </div>
            <div className="flex gap-2 shrink-0">
                <button
                    type="button"
                    onClick={() => accept("essential")}
                    className="px-4 py-2 rounded-lg border border-navy-200 text-navy-800 text-sm font-semibold hover:bg-navy-50 transition"
                >
                    Essential only
                </button>
                <button
                    type="button"
                    onClick={() => accept("all")}
                    className="px-4 py-2 rounded-lg gradient-emerald text-white text-sm font-semibold shadow-soft hover:brightness-110 transition"
                >
                    Accept all
                </button>
            </div>
        </div>
    );
}
